import QualifyingQuestions from "@forwardflow/components/Campaign/QualifyingQuestions";

const QualifyingQuestionsPage = () => {
  return (
    <>
      <QualifyingQuestions />
    </>
  );
};

export default QualifyingQuestionsPage;
